let _ = require('lodash');
let { monkey } = require('baobab');
let formatter = require('../../../helpers/formatter');

module.exports = {
    formatUsersList (state) {
        state.set(['account', 'users', 'computed', 'usersList'], monkey(
            ['account', 'users', 'list', 'data'],
            ['account', 'userForm', 'original', 'id'],
            (usersList = [], selectedUserId = '') => _.map(usersList, (item) => ({
                id: item.id,
                fullName: `${formatter.shortName(item)} (${item.email})`,
                isSelected: item.id === selectedUserId
            }))
        ));
    },

    filterUsersList (state) {
        state.set(['account', 'users', 'computed', 'usersListFiltered'], monkey(
            ['account', 'users', 'computed', 'usersList'],
            ['account', 'users', 'list', 'filter'],
            (usersList = [], filter = '') => _.filter(usersList, (item) => isMatch(item.fullName, filter))
        ));
    }
};

function isMatch (value, filter) {
    if (filter) {
        return value.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    }
    return true;
}



// WEBPACK FOOTER //
// ./actions/computed/account/users-list.js